import { useQuery, type QueryKey, type UseQueryOptions } from "react-query";
import { configService } from "../../main/src/js/services/config";
import { queryClient } from "../utils/utils";
import type { InstanceConfiguration } from "../types/config.types";
import { INSTANCE_CONFIG_QUERY_KEY } from "../constants/config.constants";

/**
 * React Query hook for config data
 * This replaces the Redux-based config loading
 */
export const useInstanceConfigQuery = (
  options?: Omit<
    UseQueryOptions<InstanceConfiguration, any>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: INSTANCE_CONFIG_QUERY_KEY as QueryKey,
    queryFn: configService.getConfig,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: 2,
    ...options
  });
};

/**
 * Synchronous config getter for use outside React components
 * This can be used in services or utilities
 */
export const getCurrentConfig = () => {
  return queryClient.getQueryData<InstanceConfiguration>(
    INSTANCE_CONFIG_QUERY_KEY
  );
};
